// extracted by mini-css-extract-plugin
module.exports = {"Text":"Text__Text--3bObU","EditAllowed":"Text__EditAllowed--3pK5Q","EditEnabled":"Text__EditEnabled--2wf60","Bold":"Text__Bold--2wA7R","glow":"Text__glow--Jykpy"};